// ##### 24-09-09 Komarov
import React, { useState } from 'react';
// ##### 25-05-21 Komarov
import IconHint from './iconHint';
// ##### 23-10-31 Komarov
import { Media } from '../../../helpers/MediaConfig';
import { RELATIVE_Z2001, WIDTH_7_5VW, VIEWBOX } from './iconStyles';

// ##### Komarov 2025-07-14
const SvgTag = ({ style = null, className = '', setIsHintShown, setY }) => {
  const onMouseEnter = e => {
    setIsHintShown(true);
    setY(e.clientY + 10);
  };

  // ##### 24-08-16 Komarov
  const onMouseLeave = () => {
    setIsHintShown(false);
    setY(undefined);
  };

  // ##### 24-05-31 Komarov
  return (
    <a href="tel:+380933266802">
      <svg
        aria-hidden="true"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={style}
        focusable="false"
        data-prefix="fas"
        data-icon="phone-square"
        // ##### 23-10-31 Komarov
        className={`svg-inline--fa fa-phone-square fa-w-14 ${className}`}
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={VIEWBOX.SIZE_512}
      >
        <path
          fill="currentColor"
          d="M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"
        />
      </svg>
    </a>
  );
};

// ##### Komarov 2025-07-14
const PhoneIcon = ({ hintText }) => {
  // ##### 23-03-15 Komarov
  const [isHintShown, setIsHintShown] = useState(false);
  const [y, setY] = useState(undefined);

  return (
    <div
      data-component="PhoneIcon"
      style={RELATIVE_Z2001}
    >
      {/* ##### 23-10-31 Komarov */}
      <Media lessThan="Laptop-1024-1440">
        <SvgTag
          style={WIDTH_7_5VW}
          className="PhoneIconMobile"
          setIsHintShown={setIsHintShown}
          setY={setY}
        />
      </Media>
      <Media greaterThanOrEqual="Laptop-1024-1440">
        <SvgTag
          style={{ width: '3vw' }}
          setIsHintShown={setIsHintShown}
          setY={setY}
        />
      </Media>
      <IconHint isHintShown={isHintShown} hintText={hintText} y={y} />
    </div>
  );
};

// ##### 25-05-21 Komarov
export default PhoneIcon;
